// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { baseGridHiddenProps } from "@store/Themes/common/props/baseGrid";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React, { FC } from "react";

/* Store Custom Code - Start */
import DataViewLoadingOverlay, {
    DataViewLoadingOverlayProps,
} from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
/* Store Custom Code - End */

export interface AccountLayoutProps extends ExpandStyles<AccountLayoutStyles> {
    id: string;
    // Store Custom Code
    contentDataView?: DataViewLoadingOverlayProps["dataView"];
}

export interface AccountLayoutStyles {
    container?: GridContainerProps;
    leftColumn?: GridItemProps;
    rightColumn?: GridItemProps;
}

export const accountLayoutStyles: AccountLayoutStyles = {
    container: baseGridHiddenProps.container,
    leftColumn: baseGridHiddenProps.sideColumn,
    rightColumn: baseGridHiddenProps.mainColumn,
};

const AccountLayout: FC<AccountLayoutProps> = ({
    id,
    extendedStyles,
    overridedStyles,
    // Store Custom Code
    contentDataView,
}) => {
    const styles = useExpandProps(accountLayoutStyles, extendedStyles, overridedStyles);

    /* Store Custom Code - Start */
    const contentZone = <Zone contentId={id} zoneName="Content" />;
    /* Store Custom Code - End */

    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.leftColumn}>
                <Zone contentId={id} zoneName="Side" />
            </GridItem>
            <GridItem {...styles.rightColumn}>
                {/* Store Custom Code - Start */}
                {contentDataView ? (
                    <DataViewLoadingOverlay dataView={contentDataView}>{contentZone}</DataViewLoadingOverlay>
                ) : (
                    contentZone
                )}
                {/* Store Custom Code - End */}
            </GridItem>
        </GridContainer>
    );
};

export default AccountLayout;
